import { styled } from '@mui/material';

const PREFIX = 'Row';

export const classes = {
  root: `${PREFIX}-root`,
};

export const Root = styled('tr')(() => ({
  [`&.${classes.root}`]: {
    '&:hover': {},
  },
}));